// ── Design decisions ──
// La posición visible de un paquete en el Manifiesto ES la del Anexo:
// PK-NN = (sort_order ?? 0) + 1 — la MISMA fórmula que buildViajeAnexoPdfInput
// (src/api/supabase/viajeroEncomienda.js, Tier 1, solo lectura). Acá no se
// inventa otra numeración: si el PDF imprimiría PK-03, la tarjeta muestra 3.
//
// OJO (discrepancia Tier-1 heredada, NO se corrige acá): addPaquete y
// confirmExtraction asignan sort_order 1-based (count+1), pero el PDF suma +1
// como si fuera 0-based. Un viaje recién creado muestra por eso posiciones
// 2..N+1 — fiel a lo que el Anexo imprimiría hoy. renumerarPaquetes normaliza
// a 0..N-1 contiguo en el PRIMER toque del operador: desde ahí manifiesto y
// PDF quedan 1..N parejos, sin duplicados ni huecos.
//
// renumerarPaquetes es pura y devuelve el mapeo COMPLETO {id, sort_order}
// para que el llamador persista por el camino de siempre (cambiarPaquete →
// autosaveViaje). Nunca muta la lista recibida; el sort es estable, así que
// los empates de sort_order conservan el orden de llegada.

export const posicionPaquete = (paquete) => (paquete?.sort_order ?? 0) + 1;

export const etiquetaPk = (paquete) => `PK-${String(posicionPaquete(paquete)).padStart(2, '0')}`;

// Mueve `paqueteId` a la posición pedida (1-based, recortada a [1, N]) y
// devuelve TODOS los paquetes renumerados 0..N-1. Id desconocido → [] (el
// llamador no persiste nada).
export const renumerarPaquetes = (paquetes, paqueteId, nuevaPosicion) => {
  const lista = Array.isArray(paquetes) ? [...paquetes] : [];
  lista.sort((a, b) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0));
  const desde = lista.findIndex((p) => p?.id === paqueteId);
  if (desde < 0) return [];
  const n = lista.length;
  const pedida = Math.round(Number(nuevaPosicion));
  const hasta = Math.min(Math.max(Number.isFinite(pedida) ? pedida : 1, 1), n) - 1;
  const [movido] = lista.splice(desde, 1);
  lista.splice(hasta, 0, movido);
  return lista.map((p, i) => ({ id: p.id, sort_order: i }));
};
